/*
 * @Author: wzh
 * @LastEditTime: 2024-05-15 09:55:17
 * @Description: auth PC路由 可不登陆访问的路由
 */
import { LoginPage, getPageLoginRoute, Logout, ThirdLogin } from "@/views/auth";
import { HelpDocument } from "@/views/help"; // 帮助文档
import { SimplyLogin } from "@/views/authPages/simplyLogin"; // 单处登录
import { UpdatePassword } from "@/views/authPages/updatePassword"; // 修改密码
import { PerfectInfo } from "@/views/authPages/perfectInfo"; // 完善资料
import { Forgotten } from "@/views/authPages/forgotten"; // 防遗忘
import { Unsleep } from "@/views/authPages/unsleep"; // 解休眠
import { SecondAuth } from "@/views/authPages/secondAuth"; // 二次认证
import { NotAccess } from "@/views/error/index";

export default [
  // PC登录
  {
    path: "/authserver/login",
    name: LoginPage.name,
    component: getPageLoginRoute(), //LoginPage,
    meta: { title: "登录", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/help",
    name: HelpDocument.name,
    component: HelpDocument,
    meta: { title: "帮助文档", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/perfectInfo",
    name: PerfectInfo.name,
    component: PerfectInfo,
    meta: { title: "完善资料", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/forgotten",
    name: Forgotten.name,
    component: Forgotten,
    meta: { title: "信息防遗忘", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/unsleep",
    name: Unsleep.name,
    component: Unsleep,
    meta: { title: "账户解休眠", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/secondAuth",
    name: SecondAuth.name,
    component: SecondAuth,
    meta: { title: "二次认证", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/updatePassword",
    name: UpdatePassword.name,
    component: UpdatePassword,
    meta: { title: "修改密码", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/simplyLogin",
    name: SimplyLogin.name,
    component: SimplyLogin,
    meta: { title: "单处登录", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/authserver/logout",
    name: "logout",
    component: Logout,
  },

  // 第三方登录
  {
    path: "/thirdLogin/:id",
    name: ThirdLogin.name,
    component: ThirdLogin,
    meta: { title: "第三方登录", keepAlive: false, menu: false, menuLevel: 1 },
  },
  {
    path: "/thirdBind/:id",
    name: ThirdLogin.name,
    component: ThirdLogin,
    meta: { title: "第三方登录", keepAlive: false, menu: false, menuLevel: 1 },
  },
  // author: wzh, date: 2023-07-31, for: 应用无法访问
  {
    path: "/notAccess",
    name: NotAccess.name,
    component: NotAccess,
  },
];
